'use strict';

frontendApp.directive('iioBindHtml', ['$compile', function($compile) {

    return {
        restrict:'A',
        link: function(scope, element, attrs) {
            scope.$watch(attrs.iioBindHtml, function(newValue, oldValue) {
                if (newValue) {
                    var content = $compile(newValue)(scope);
                    element.append(content);
                }
            });
        }
    };
    
}]);